import { useContext } from 'react';
import { StoresContext } from '../../../App';

const features = {
    Wholesale: 'Офис продаж',
    WebStore: 'Интернет магазин',
    Retail: 'Розничный магазин',
    Designer: 'Проектирование',
    PanelAssembly: 'Монтаж',
    Service: 'Сервис',
    '': 'Все',
};

export default function FeatureFilters() {
    const { featureFilters, setFeatureFilters } = useContext(StoresContext);
    const selectedFeature = (featureFilters[0]?.code as keyof typeof features) || '';
    return (
        <table className="mn-type-filters" style={{ width: '100%' }}>
            <tbody>
                <tr>
                    {Object.entries(features).map(([code, name]) => (
                        <td
                            key={code}
                            className={
                                'type-filter' +
                                (code === selectedFeature ? ' marketnavigator-block-active' : '')
                            }
                            onClick={() => setFeatureFilters(code ? [{ code, value: null }] : [])}
                        >
                            {name}
                        </td>
                    ))}
                </tr>
            </tbody>
        </table>
    );
}
